import BusinessRegistrationService from '../services/business-registration-service';

export const businessRegistration = {
  namespaced: true,
  state: {
    business: null,
    verification: null,
    verificationScheduleDate: null,
    verificationActivityLog: null,
  },
  actions: {
    getByBusinessRegistrationNumber({ commit }, { businessRegistrationNumber }) {
      commit('setIsBusy', true, { root: true });
      commit('setBusinessRegistration', null);
      commit('setVerification', null);
      commit('setVerificationScheduleDate', null);
      commit('setVerificationActivityLog', null);
      return BusinessRegistrationService.getByBusinessRegistrationNumber(businessRegistrationNumber)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setBusinessRegistration', result);
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    createVerification({ commit }, { businessRegistrationNumber }) {
      commit('setIsBusy', true, { root: true });
      return BusinessRegistrationService.createVerification(businessRegistrationNumber)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    getVerificationScheduleDate({ commit }, { businessRegistrationNumber }) {
      commit('setIsBusy', true, { root: true });
      return BusinessRegistrationService.getVerificationScheduleDate(businessRegistrationNumber)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setVerificationScheduleDate', result.model);
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    getVerification({ commit }, { businessRegistrationNumber }) {
      commit('setIsBusy', true, { root: true });
      return BusinessRegistrationService.getVerification(businessRegistrationNumber)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setVerification', result.model);
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    getVerificationActivityLogs({ commit }, { businessRegistrationNumber }) {
      commit('setIsBusy', true, { root: true });
      return BusinessRegistrationService.getVerificationActivityLogs(businessRegistrationNumber)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setVerificationActivityLog', result.model);
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    getCompaniesHouseFile({ commit }, documentId) {
      commit('setIsBusy', true, { root: true });
      return BusinessRegistrationService.getCompaniesHouseFile(documentId)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
  },
  mutations: {
    setBusinessRegistration(state, newState) {
      state.business = newState;
    },
    setVerification(state, verification) {
      state.verification = verification;
    },
    setVerificationScheduleDate(state, verificationScheduleDate) {
      state.verificationScheduleDate = verificationScheduleDate;
    },
    setVerificationActivityLog(state, verificationActivityLog) {
      state.verificationActivityLog = verificationActivityLog;
    },
  },
};
